












































export default
    props:
        score: Number
        time: String
        where: String
        who: String
        review: String
    computed:
        form_score:
            get: -> return @score
            set: (value) -> @$emit('update:score', parseInt(value))
        form_time:
            get: -> return @time
            set: (value) -> @$emit('update:time', value)
        form_where:
            get: -> return @where
            set: (value) -> @$emit('update:where', value)
        form_who:
            get: -> return @who
            set: (value) -> @$emit('update:who', value)
        form_review:
            get: -> return @review
            set: (value) -> @$emit('update:review', value)
